import { memo } from 'react';

import TimestampTooltip from '@/components/atoms/TimestampTooltip/TimestampTooltip';
import { cn } from '@/lib/utils';
import { formatTimeOnly } from '@/util/dateUtils';

interface Props {
  created: string | null;
  authorType: string;
  shouldShow: boolean;
}
const MessageStatus = ({ created, authorType, shouldShow }: Props) => {
  const time = created ? formatTimeOnly(created) : '';

  return (
    shouldShow && (
      <div
        className={cn(
          'mt-1 mb-3 flex items-center',
          authorType === 'visitor' ? 'justify-start' : 'mr-8 justify-end'
        )}
      >
        <TimestampTooltip timestamp={created} side="top">
          <span className="cursor-default text-xs leading-5 font-normal text-foreground-muted select-none">
            {time}
          </span>
        </TimestampTooltip>
      </div>
    )
  );
};

export default memo(MessageStatus);
